import { gql } from '@/features/graphql/generated'

export const CartItemFragment = gql(/* GraphQL */ `
    fragment CartItem on CartItem {
        uuid
        productVariant {
            uuid
            product {
                uuid
                name
            }
            name
            price {
                amount
                currency
            }
            container {
                uuid
                internalName
                price {
                    amount
                    currency
                }
            }
        }
        quantity
        totalProductPrice {
            amount
            currency
        }
        toppingGroupToppings {
            ...CartItemTopping
        }
        additionGroupProductVariants {
            ...CartItemAddedProductVariant
        }
        removedRecipeIngredients {
            ...RecipeIngredient
        }
    }
`)
